import React from "react";
import PropTypes from "prop-types";
import { Icon } from "../../../../../atoms/icon";
import { copyToClipboard } from "../../../../../utils/utils";
import { GA, DeepBI } from "../../../../../../integrations";

import styles from "./styles.m.css";

export class SocialShareTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      showCopiedModal: false
    };
    this.hanldeAction = this.hanldeAction.bind(this);
  }

  handleClick(args) {
    GA.customEvent(args, this.props.storyId);
    DeepBI.customEvent(args, this.props.storyId);
    try {
      if (copyToClipboard(window.location.href)) {
        this.setState({
          showCopiedModal: true
        });

        setTimeout(() => {
          this.setState({
            showCopiedModal: false
          });
        }, 3000);
      } else {
        // how to convey failure to user
      }
    } catch (err) {
      console.log(err.message);
    }
  }

  hanldeAction(args) {
    const { handleClickView } = this.props;
    GA.customEvent(args, this.props.storyId);
    DeepBI.customEvent(args, this.props.storyId);
    handleClickView();
  }

  render() {
    const { fbUrl, twitterUrl, mailtoUrl, whatsappUrl, handleShare, className } = this.props;

    return (
      <div className={`${className} ${styles["social-share"]}`}>
        <ul className={`${styles["social-share__icons"]}`}>
          <li className={styles["share-label"]}> Share via :</li>
          <li className={`${styles["social-share__whatsapp"]} ${styles["social-share__icon--whatsapp"]}`}>
            <a
              aria-label="whatsapp share"
              href={`${whatsappUrl}${encodeURIComponent("?utm_source=mobile&utm_medium=whatsapp")}`}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__whatsapp-icon"]}`}
              onClick={this.hanldeAction.bind(this, "whatsapp")}
            >
              <Icon type="whatsapp" />
            </a>
          </li>

          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--facebook"]}`}>
            <a
              aria-label="facebook share"
              href={fbUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__fb-icon"]}`}
              onClick={this.hanldeAction.bind(this, "facebook")}
            >
              <Icon type="facebook" />
            </a>
          </li>
          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon-twitter"]}`}>
            <a
              aria-label="twitter share"
              href={twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__twitter--icon"]}`}
              onClick={this.hanldeAction.bind(this, "twitter")}
            >
              <Icon type="twitter" />
            </a>
          </li>
          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--email"]}`}>
            <a
              aria-label="e-mail share"
              href={mailtoUrl}
              className={`${styles["social-share__link"]} ${styles["social-share__email-icon"]}`}
              onClick={this.hanldeAction.bind(this, "e-mail")}
            >
              <Icon type="email" />
            </a>
          </li>

          {handleShare && (
            <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--app-share"]}`}>
              <button
                aria-label="Share this"
                onClick={handleShare}
                className={`${styles["social-share__link"]} ${styles["social-share__share-app-share"]}`}
                role="button"
              >
                <Icon type="mobile-share" />
              </button>
            </li>
          )}

          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon-copy"]}`}>
            {this.state.showCopiedModal && <span className={styles["copy-modal"]}>Copied story url for sharing</span>}
            <button
              aria-label="show message"
              role="button"
              onClick={this.handleClick.bind(this, "copy")}
              className={`${styles["social-share__link"]} ${styles["social-share__copy-icon"]}`}
            >
              <Icon type="clipboard" />
            </button>
          </li>
          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon-newsletter"]} newsletter`}>
            <a
              aria-label="newsletter share"
              onClick={this.hanldeAction.bind(this, "comments")}
              className={`${styles["social-share__link"]} ${styles["social-newsletter__icon"]}`}
            >
              <Icon type="newsletter" />
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

SocialShareTemplate.propTypes = {
  className: PropTypes.string,
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  mailtoUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  handleShare: PropTypes.func,
  handleClickView: PropTypes.func,
  color: PropTypes.string,
  storyId: PropTypes.string
};
